<div class="fix-action-row" data-qa="import-dialog">
  <div mat-dialog-content>

    <mat-horizontal-stepper
      linear="true"
      data-qa="stepper"
      #stepper>
      <mat-step>
        <form>
          <ng-template matStepLabel>Excel Datei auswählen</ng-template>

          <div style="padding-bottom: 20px;">
            <p>
              Hier sind Sie richtig, um Erzeugungsanlagen anhand eines Excel-Dokuments zu importieren. Da
              das Excel-Dokument gewissen Formalien entsprechen muss, empfehlen wir,
              vorher über das TNB-Portal ihre Erzeugungsanlagen zu exportieren. Sie erhalten dann ein
              Excel-Dokument zum Download, in dem Sie bestehende Erzeuger modifizieren, löschen und
              hinzufügen können. Eine ausführliche Dokumentation zum Import finden Sie hier.
            </p>
          </div>

          <tnb-upload-file-form
              allowedFileMimeType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              allowedFileTypeName="Excel"
              (fileEventEmitter)="handleFileChange($event)"
          ></tnb-upload-file-form>
        </form>

      </mat-step>

      <mat-step>
        <form>
          <ng-template matStepLabel>Ergebnis überprüfen</ng-template>

          @if (!importReport && job) {
            <div>
              @if (!backendFailure) {
                <div>
                  <mat-progress-bar
                    class="progress-bar"
                    [color]="'primary'"
                    [mode]="'determinate'"
                    [value]="(job.nrProcessedTransformations / job.erzeugerTotal) * 100">
                  </mat-progress-bar>
                  <table class="phase-table">
                    <tr>
                      <td>
                        @if (job.phase <= 10) {
                          <mat-icon class="spinner">check_box_outline_blank</mat-icon>
                        }
                        @if (job.phase > 10) {
                          <mat-icon class="progress-done">check_box</mat-icon>
                        }
                      </td>
                      <td>
                        <span
                            [class.bold]="job.phase === 10">
                            Laden und Prüfen des Excel-Dokuments
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        @if (job.phase <= 20) {
                          <mat-icon class="spinner">check_box_outline_blank</mat-icon>
                        }
                        @if (job.phase > 20) {
                          <mat-icon class="progress-done">check_box</mat-icon>
                        }
                      </td>
                      <td>
                        <span [class.bold]="job.phase === 20">
                            Analysieren und Validieren von {{job.nrProcessedTransformations}} / {{job.erzeugerTotal}} Erzeugungsanlagen
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        @if (job.phase <= 30) {
                          <mat-icon class="spinner">check_box_outline_blank</mat-icon>
                        }
                        @if (job.phase > 30 || job.done) {
                          <mat-icon class="progress-done">check_box</mat-icon>
                        }
                      </td>
                      <td>
                        <span [class.bold]="job.phase === 30">
                            Prüfe auf ungültige oder gelöschte Westnetz-IDs
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        @if (job.phase <= 40) {
                          <mat-icon class="spinner">check_box_outline_blank</mat-icon>
                        }
                        @if (job.phase > 40) {
                          <mat-icon class="progress-done">check_box</mat-icon>
                        }
                      </td>
                      <td>
                        <span [class.bold]="job.phase > 30">
                            Bereite Prüfbericht vor
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>
              }
              @if (backendFailure) {
                <div class="backend-failure">
                  <img class="backend-failure-image"
                    src="/assets/innogy-icons/smileys/innogy_picto_smiley_sad.svg">
                  </div>
                  Es ist leider ein Fehler bei der Kommunikation mit dem Server aufgetreten und die
                  Erzeugungsanlagen konnten nicht geprüft werden. Wir empfehlen, den Importvorgang noch
                  einmal
                  neu zu beginnen.
                }
              </div>
            }
            @if (importReport) {
              <tnb-importreport-display
              [erzeugungsanlagenImportReport]="importReport"></tnb-importreport-display>
            }

          </form>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Fertig</ng-template>
          @if (!importReport && job) {
            @if (!backendFailure) {
              <mat-progress-bar
                class="progress-bar"
                [color]="'primary'"
                [mode]="'determinate'"
                [value]="((job.nrProcessedTransformations  + job.nrStoredErzeuger) / (job.erzeugerTotal * 2)) * 100">
              </mat-progress-bar>
              <table class="phase-table">
                <tr>
                  <td>
                    @if (job.phase <= 10) {
                      <mat-icon class="spinner">check_box_outline_blank</mat-icon>
                    }
                    @if (job.phase > 10) {
                      <mat-icon class="progress-done">check_box</mat-icon>
                    }
                  </td>
                  <td>
                    <span [class.bold]="job.phase === 10">
                        Laden und Prüfen des Excel-Dokuments
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    @if (job.phase <= 20) {
                      <mat-icon class="spinner">check_box_outline_blank</mat-icon>
                    }
                    @if (job.phase > 20) {
                      <mat-icon class="progress-done">check_box</mat-icon>
                    }
                  </td>
                  <td>
                    <span [class.bold]="job.phase === 20">
                        Analysieren und Validieren von {{job.nrProcessedTransformations}} / {{job.erzeugerTotal}} Erzeugungsanlagen
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    @if (job.phase <= 30) {
                      <mat-icon class="spinner">check_box_outline_blank</mat-icon>
                    }
                    @if (job.phase > 30) {
                      <mat-icon class="progress-done">check_box</mat-icon>
                    }
                  </td>
                  <td>
                    <span [class.bold]="job.phase === 30">
                        Prüfe auf ungültige oder gelöschte Westnetz-IDs
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    @if (job.phase <= 40) {
                      <mat-icon class="spinner">check_box_outline_blank</mat-icon>
                    }
                    @if (job.phase > 40) {
                      <mat-icon class="progress-done">check_box</mat-icon>
                    }
                  </td>
                  <td>
                    <span [class.bold]="job.phase === 40">
                        Speichern von {{job.nrStoredErzeuger}} / {{job.erzeugerTotal}} Erzeugungsanlagen in der Datenbank
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    @if (job.phase < 50) {
                      <mat-icon class="spinner">check_box_outline_blank</mat-icon>
                    }
                    @if (job.done) {
                      <mat-icon class="progress-done">check_box</mat-icon>
                    }
                  </td>
                  <td>
                    <span [class.bold]="job.phase === 50">Importvorgang abschließen</span>
                  </td>
                </tr>
              </table>
            }
            @if (backendFailure) {
              <div class="backend-failure">
                <img class="backend-failure-image"
                  src="/assets/innogy-icons/smileys/innogy_picto_smiley_sad.svg">
                </div>
                Es ist leider ein Fehler bei der Kommunikation mit dem Server aufgetreten und die
                Erzeugungsanlagen wurden möglicherweise nicht importiert. Wir empfehlen, den Importvorgang
                noch einmal
                neu zu beginnen.
              }
            }
            @if (importReport && job) {
              @if (importReport.success) {
                <div>
                  <h2>Die Anlagen wurden erfolgreich importiert</h2>
                </div>
              }
              @if (!importReport.success) {
                <div>
                  <h2>Es ist leider ein Fehler beim Import aufgetreten. Sollte der Import bei einem erneuten
                    Versuch
                    wiederholt scheitern, schicken Sie das Excel-Dokument zur Prüfung bitte an Ihren
                  Kundenbetreuer.</h2>
                </div>
              }
            }

          </mat-step>
        </mat-horizontal-stepper>
      </div>

      <div class="spacer"></div>

      <div mat-dialog-actions class="wizard-footer">
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }

        <div class="wizard-footer-left">
          @if (stepper.selectedIndex !== 2) {
            <button
              matButton="outlined"
              data-qa="abort-button"
              (click)="close()">
                <mat-icon svgIcon="innogy_picto_close"></mat-icon>
            Abbrechen
          </button>
        }
      </div>

      <div class="wizard-footer-right">

        @if (stepper.selectedIndex === 0) {
          <button
            matButton="filled"
            [disabled]="!selectedFile"
            data-qa="upload-and-check-button"
            (click)="upload(true)">
              <mat-icon svgIcon="innogy_picto_check"></mat-icon>
            Datei hochladen und prüfen
          </button>
        }

        @if (stepper.selectedIndex === 1) {
          <button
            matButton="filled"
            data-qa="start-import-button"
            [disabled]="!importReport?.success"
            (click)="upload(false)">
              <mat-icon>file_upload</mat-icon>
            Import starten
          </button>
        }

        @if (stepper.selectedIndex === 2) {
          <button
            matButton="filled"
            color="primary"
            data-qa="close-button"
            (click)="close()">Schließen
          </button>
        }

      </div>
    </div>
  </div>
